import { render, staticRenderFns } from "./VideoManage.vue?vue&type=template&id=1de5a164&scoped=true"
import script from "./VideoManage.vue?vue&type=script&lang=js"
export * from "./VideoManage.vue?vue&type=script&lang=js"
import style0 from "./VideoManage.vue?vue&type=style&index=0&id=1de5a164&prod&lang=scss&scoped=true"
import style1 from "./VideoManage.vue?vue&type=style&index=1&id=1de5a164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5a164",
  null
  
)

export default component.exports